import { ModelBase } from 'store/model-base';

export class NowAccountBadgesCollection extends ModelBase {
    public static storeName: string = 'nowAccountBadgesCollection';

    public products: NowAccountProducts;

    public static create<T extends ModelBase>(initData: object): T {
        const toReturn: NowAccountBadgesCollection = super.create<NowAccountBadgesCollection>(initData);

        return super.create<T>(toReturn);
    }
}
